import MyDialog from "~/mui/MyDialog";
import { useTrans } from "~/hooks/useTrans";

interface ILeaveModal {
	onClose?: () => void;
	onSave?: () => void;
}

export default function LeaveModal({
	onClose = () => {},
	onSave = () => {},
}: ILeaveModal) {
	const { trans } = useTrans();

	return <MyDialog title={trans("leaveDialog.title")} onClose={onClose} onSave={() => onSave()} cancelCaption={ trans("cancel") } saveCaption={ trans("leaveDialog.leaveBtn") }
	>
		<p>
			{ trans("leaveDialog.desc") }
		</p>
	</MyDialog>;
}
